module.exports = __webpack_public_path__ + "img/duplikuj.7484b1cd.svg";